<template>
  <div>
    <video
      :style="videoStyle"
      :id="videoId"
      style="object-fit: fill"
      controls
      autoplay
      autobuffer
      muted
      preload="auto"
    ></video>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default: null
    },
    myid: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      scriptNames: ["webrtcstreamer.js", "adapter.min.js"],
      webRtcServer: null
    }
  },
  computed: {
    videoId() {
      return `camera_video_${this.myid.container_id}_${this.myid.rect_id}`
    },
    videoStyle() {
      return {
        width: this.options.width + "px",
        height: this.options.height + "px"
      }
    }
  },
  methods: {
    createScript(url) {
      const script = document.createElement("script")
      const scriptSrc = url
      script.setAttribute("src", scriptSrc)
      script.setAttribute("type", "text/javascript")
      script.setAttribute("async", "async")
      return script
    },
    getAllScriptSrc() {
      return Array.prototype.map
        .call(document.getElementsByTagName("script"), item => item.src)
        .filter(item => typeof item === "string")
    },
    getNeedInitScript(scriptNames, allScriptSrc) {
      return scriptNames.filter(name => allScriptSrc.find(_name => _name.includes(name)) === undefined)
    },
    initScript() {
      return new Promise((resolve, reject) => {
        const allScriptSrc = this.getAllScriptSrc()
        const scriptEls = []
        const needInitScript = this.getNeedInitScript(this.scriptNames, allScriptSrc)
        //有需要添加的script标签，进行添加操作后再resolve
        if (needInitScript.length) {
          let status = 0
          needInitScript.forEach(name => {
            const scriptEl = this.createScript(`${process.env.VUE_APP_CDN_BASE_URL}/lib-modules/${name}`)
            status++
            scriptEls.push(scriptEl)
            scriptEl.onload = function () {
              status--
              console.log("load", name)
              //等待全部script标签加载完成后 进行resolve
              if (status === 0) resolve()
            }
            scriptEl.onerror = function () {
              reject()
            }
          })
          scriptEls.forEach(el => document.body.appendChild(el))
        } else {
          //没有需要添加的script标签，直接resolve
          resolve()
        }
      })
    },
    init() {
      this.initScript().then(() => {
        //video：需要绑定的video控件ID
        //192.168.1.226：启动webrtc-streamer的设备IP
        this.webRtcServer = new WebRtcStreamer(this.videoId, location.protocol + "//192.168.1.203:8000")
        //需要查看的rtsp地址
        this.webRtcServer.connect("rtsp://wowzaec2demo.streamlock.net/vod/mp4:BigBuckBunny_115k.mp4")
        window.onbeforeunload = function () {
          this.webRtcServer.disconnect()
        }
      })
    }
  },
  mounted() {
    this.init()
    console.log("process.env.CDN_BASE_URL,12", process.env)
  },
  beforeDestroy() {
    this.webRtcServer.disconnect()
  }
}
</script>

<style>
</style>